import { render, staticRenderFns } from "./ModalLuxUnionEdit.vue?vue&type=template&id=a89f2364&scoped=true"
import script from "./ModalLuxUnionEdit.vue?vue&type=script&lang=js"
export * from "./ModalLuxUnionEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalLuxUnionEdit.vue?vue&type=style&index=0&id=a89f2364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89f2364",
  null
  
)

export default component.exports